import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

export function usePetitionPageStateData(): unknown {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		const {
			id,
			user,
			organization,
			createdAt,
			signatureState: { signatureCount, signatureGoal },
			weeklySignatureCount,
			tagsConnection,
			geoReach,
			relevantLocationLocalizedName,
		} = petition;

		return {
			id,
			user: {
				id: user.id,
				displayName: user.displayName,
				photo: user.photo,
			},
			organization: organization
				? {
						id: organization.id,
						name: organization.name,
						photo: organization.photo,
					}
				: undefined,
			createdAt,
			signatureCount: {
				displayed: signatureCount.displayed,
				total: signatureCount.total,
				goal: signatureGoal.displayed,
			},
			weeklySignatureCount,
			tags: tagsConnection ? tagsConnection.nodes : [],
			geoReach,
			relevantLocationLocalizedName,
		};
	}, [petition]);
}
